// components/ui/AddNewButton.jsx
import { Link, useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import { usePermissions } from "../../context/PermissionContext";

// Add Button
export const AddButton = ({
  onClick,
  label,
  permissionKey = "no_key",
  permission = false,
  icon = "ic:baseline-plus",
}) => {
  const { hasPermission } = usePermissions();

  if (!hasPermission(permissionKey) && permission === false) return null;

  return (
    <button
      onClick={onClick}
      className="btn btn-primary-600 not-active px-12 py-6 text-sm d-flex align-items-center gap-2"
      aria-label={label}
    >
      <Icon icon={icon} className="icon text-xl line-height-1" />
      {label}
    </button>
  );
};
// Cancel Button (Form)
export const CancelButtonForm = ({ onClick = "", label = "Cancel" }) => {
  const navigate = useNavigate();
  return (
    <button
      type="button"  // Add this line - important!
      onClick={() => navigate(-1)}
      className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-56 py-11 radius-8"
      aria-label={label}
    >
      {label}
    </button>
  );
};
// Update Button (Form)
export const UpdateButtonForm = ({
  label = "Submit",
  type = "submit",
  disabled = false,
  onClick,
}) => {
  const navigate = useNavigate();
  return (
    <button
      type={type}
      disabled={disabled}
      aria-label={label}
      onClick={()=>console.log(disabled)}
      className="btn btn-primary-600 border border-primary-600 text-md px-56 py-12 radius-8"
    >
      {disabled ? "Please Wait..." : label}
    </button>
  );
};
